import moment from "moment/moment";
import React, { useEffect } from "react";
import { VStack } from "native-base";
import FormInput from "../../../../shared/components/common/FormInput";
import { t } from "../../../../shared/services/i18n";
import AdvanceSelect from "../../../../shared/components/common/AdvanceSelect";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "react-native-toast-notifications";
import { setError } from "../../../../shared/redux/stepperSlice";


const BuildUniformReport = (props) => {
    const { setFieldValue, values, touched, errors, validationObject, handleChange } = props
    const error = useSelector((state) => state.stepper.error);
    const toast = useToast()
    const dispatch = useDispatch()


    const years = useMemo(() => {
        return Array.from({ length: 5 }, (_, i) => moment().subtract(i, 'year').format('YYYY'))
    }, [])

    useEffect(() => {
        if(error && error !== '') {
            toast.show(t(error?.message), { type: 'danger', duration: 5000 });
            dispatch(setError(null))
        }
    }, [error]);

    return (
        <VStack space={'1.5rem'}>
            <FormInput
                label={t('tax-year')}
                name={'tax_year'}
                onChangeCallback={handleChange('tax_year')}
                error={touched.tax_year && errors.tax_year}
                containerProps={{ mb: 0 }}
                width={'100%'}
            >
                <AdvanceSelect options={years.map(year => ({value: year, label: year}))}
                    initValue={values.tax_year} onChange={(option) => setFieldValue('tax_year', option?.value ?? null)}
                    isError={touched.tax_year && errors.tax_year} />
            </FormInput>
        </VStack>

    )
}

export default BuildUniformReport